import { render, staticRenderFns } from "./Panoptico.vue?vue&type=template&id=6ccc341b"
import script from "./Panoptico.vue?vue&type=script&lang=js"
export * from "./Panoptico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports